import {GroupRole} from "fearless-common";

const groupRole: Record<GroupRole, { label: string; value: GroupRole }> = {
    MANAGER: {
        label: 'Admin',
        value: GroupRole.Manager,
    },
    MEMBER: {
        label: 'Member',
        value: GroupRole.Member,
    },
}

export function getRoleLabel(role: GroupRole): string {
    return groupRole[role]?.label;
}

export function getGroupRoleOptions() {
    return Object.values(groupRole);
}
